import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';

export function useCompanionDeck() {
  return useQuery({
    queryKey: ['marketplace', 'companion-deck'],
    queryFn: () => marketplaceService.getCompanionDeck(),
  });
}

export function useMyMatches() {
  return useQuery({
    queryKey: ['marketplace', 'companion-matches'],
    queryFn: () => marketplaceService.getMyMatches(),
  });
}

export function useDecideCompanion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: marketplaceService.decideCompanion,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['marketplace', 'companion-deck'] });
      qc.invalidateQueries({ queryKey: ['marketplace', 'companion-matches'] });
    },
  });
}
